// Регистрация панели реестра долгов в каркасе. Побочный эффект при загрузке модуля.

import { registerPanel } from '@/layout/panel-registry';

import { PANEL_DEBT, PANEL_DEBTS_TRANSFER } from '../../route';

import { DebtPanel } from './DebtPanel';
import { OpeningBalancesPanel } from './OpeningBalancesPanel';

registerPanel(PANEL_DEBT, {
  title: () => 'Долг',
  render: ({ id }) => <DebtPanel id={id} />,
});

registerPanel(PANEL_DEBTS_TRANSFER, {
  title: () => 'Перенос остатков долгов',
  render: () => <OpeningBalancesPanel />,
});
